<script setup lang="ts">
  import ScrollToTop from '@core/components/ScrollToTop.vue';

  // import { useScreenPrintBlocker } from '@core/composable/useScreenPrintBlocker';
  import { useThemeConfig } from '@core/composable/useThemeConfig';
  import { useTheme } from 'vuetify';

  import { hexToRgb } from '@layouts/utils';

  const {
    syncInitialLoaderTheme,
    syncVuetifyThemeWithTheme: syncConfigThemeWithVuetifyTheme,
    isAppRtl,
    handleSkinChanges
  } = useThemeConfig();

  const { global } = useTheme();

  // ℹ️ Sync current theme with initial loader theme
  syncInitialLoaderTheme();
  syncConfigThemeWithVuetifyTheme();
  handleSkinChanges();

  // useScreenPrintBlocker();
</script>

<template>
  <VLocaleProvider :rtl="isAppRtl">
    <!-- ℹ️ This is required to set the background color of active nav link based on currently active global theme's primary -->
    <VApp :style="`--v-global-theme-primary: ${hexToRgb(global.current.value.colors.primary)}`">
      <RouterView />
      <ScrollToTop />
      <!-- <Loader /> -->
      <ConfirmDialog />
      <OrientationLock />
    </VApp>
  </VLocaleProvider>
</template>
